export default "/WebApp/dist/assets/svg/textFile.svg";